import { useAuth } from '../auth/AuthProvider';
import { SimboloMarcaBlanco } from '../components/Marca';
import { IconChevron } from './icons';
import { DESTINOS_NAV } from './navItems';
import { SidebarNav } from './SidebarNav';

interface Props {
  colapsado: boolean;
  onToggle: () => void;
}

/** Sidebar fijo a la izquierda (navy), colapsable de 64px a ancho completo. */
export function Sidebar({ colapsado, onToggle }: Props) {
  const { tieneRol } = useAuth();
  const destinos = DESTINOS_NAV.filter((d) => tieneRol(...d.roles));

  return (
    <aside
      className={[
        'sticky top-0 hidden h-dvh shrink-0 flex-col bg-navy py-5 transition-[width] duration-200 md:flex',
        colapsado ? 'w-16' : 'w-64',
      ].join(' ')}
    >
      <div className="relative">
        <div className={['flex items-center', colapsado ? 'justify-center' : 'gap-2.5 px-4'].join(' ')}>
          <SimboloMarcaBlanco className="h-12 w-12 shrink-0" />
          {!colapsado && (
            <span className="font-marca truncate text-lg font-semibold text-white">
              Eventos CIEN
            </span>
          )}
        </div>

        <button
          type="button"
          onClick={onToggle}
          aria-label={colapsado ? 'Expandir menú' : 'Colapsar menú'}
          className="absolute -right-3 top-1 flex h-6 w-6 items-center justify-center rounded-full border border-borde bg-white text-navy shadow-sm transition active:scale-[0.98]"
        >
          <IconChevron
            className={['h-3.5 w-3.5 transition-transform', colapsado ? '' : 'rotate-180'].join(' ')}
          />
        </button>
      </div>

      <div className="mt-8 flex-1 overflow-y-auto">
        <SidebarNav destinos={destinos} colapsado={colapsado} />
      </div>
    </aside>
  );
}
